// @flow
import * as React from 'react';
import { wrapper } from './styles';

type Props = {
  children: React.ChildrenArray<*>,
};

export default function Features({ children }: Props): React.Node {
  return (
    <div className="features-wrapper">
      <ul className="features">{children}</ul>
      <style jsx>{wrapper}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/components/mobile/Features/shared/index.js